// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"c3c1ba13","190":"c480ba2b","608":"c480ba2b","722":"8c7ad1af","730":"b58e5ea6"}[chunkId] + ".chunk.css";
};